// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi} from '@reduxjs/toolkit/query/react';
import {fetchBaseQueryWrapper} from '../fetch-base-query-wrapper.ts';
import {tags} from '../api-slices/api-tags.ts';

// Every tag that an injected endpoint provides or invalidates MUST be
// registered here: RTK Query silently ignores tags absent from `tagTypes`
// for cache invalidation (and warns in dev). Derive the list from the tags
// map so a newly added tag can never be forgotten — the previous hardcoded
// `[tags.shimAgent]` left credential / identifier / contact / registry /
// notification invalidations as silent no-ops.
export const tagTypes = Object.values(tags);

// initialize an empty api service that we'll inject endpoints into later as needed
export const originApiSlice = createApi({
  reducerPath: 'originApi',
  baseQuery: fetchBaseQueryWrapper({}),
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  tagTypes,
});
